import { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'
import { SWRConfig } from 'swr'
import { CosignRoutes } from './components/cosign/CosignRoutes'
import { MyAccountDialogProvider } from './components/cosign/myAccount/Provider/MyAccountDialogProvider'
import { type CosignContextProps, CosignContext } from './components/useContextCosign'
import cosignInstance from './i18n/i18nConfig'
import { withCosignTooManyRequests } from './middlewares/withCosignTooManyRequests'

export const Cosign = (props: CosignContextProps) => {
  useEffect(() => {
    const styles = `#wrapper {
      padding-bottom: 0 !important;
    }


    /* FIXME: for flatsome  */
    input {
      box-shadow: none !important;
    }

    html {
      height: 100%;
    }


    body {
      margin: 0;
      box-sizing: border-box;
      /*
      * Rewrite Flatsome default style
      * Fix app-bar sticky
      */
      overflow-x: unset;
      height: 100%;
    }`
    const styleSheet = document.createElement('style')
    styleSheet.innerText = styles
    document.head.prepend(styleSheet)

    return () => {
      if (styleSheet) {
        document.head.removeChild(styleSheet)
      }
    }
  }, [])

  return (
    <CosignContext.Provider value={props}>
      <I18nextProvider i18n={cosignInstance}>
        <MyAccountDialogProvider>
          <SWRConfig value={{ use: [withCosignTooManyRequests] }}>
            <CosignRoutes />
          </SWRConfig>
        </MyAccountDialogProvider>
      </I18nextProvider>
    </CosignContext.Provider>
  )
}
